//存放数据
const state = {
    count: 0
}
//修改数据，调用方式this.$store.commit('increment', 2)
const mutations = {

}
//专门处理异步，调用方式：this.$store.dispatch('fetchUser')
const actions = {
    bind({ commit, rootState }, payload) {
        // console.log("------------context", context)
        // console.log("---------window.ELECTRONAPI",window.ELECTRONAPI)
        if (rootState.eapi) {
            rootState.eapi.bindBy("vue-write-text", async (params, call) => {
                let blob = new Blob([params.buf], { type: "image/jpg" });
                let url = URL.createObjectURL(blob);
                let img = new Image();
                let canvas = document.createElement("canvas");
                canvas.width = 600;
                canvas.height = 800;
                img.src = url;
                img.onload = () => {
                    let ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    ctx.textBaseline = 'top';
                    ctx.font = '18px Arial';
                    ctx.fillStyle = "blue";
                    ctx.fillText("你好呀", 10, 10);
                    let dataURL = canvas.toDataURL('image/jpeg');
                    call({ code: 1, msg: "回去", data: window.$func.base64ToArrayBuffer(dataURL) })
                    console.log("-------------vue-write-text")
                }
            })
        }

    },
}
//state 的计算属性，像 computed，使用方式：this.$store.getters.isLogin
const getters = {

}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}